module.exports = "https://static.wmbcdn.com/uniweb/images/4c9bd9e371ebd92ced6c95098c3f2809.svg";